module.exports = __webpack_public_path__ + "static/img/jigou-gansu-bottom.5e3ea46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-gansu-bottom.png
// module id = AYqQ
// module chunks = 2